// In this folder, common variables can be accessed and edited in a single place.
export default {
  data() {
    return {
      // Name of the module defined in user rights. eg. blog for blog.edit, blog.add etc..
      permission: 'usergroups',
      // Where data is fetched from
      endpoint: 'usergroup',
      // The object key from the response object
      responseData: {
        single: 'usergroup',
        multiple: 'usergroups',
      },
      // Used for navigation on the front-end (matching the router)
      module: 'usergroups',
    };
  },
};
